
define('ldsh!common/templates/error_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="md__general__content__empty mt48">\n  <div>\n    <img alt="404"\n      src="https://static.mdirector.com/assets/themes/vEmBlue/globals/src/images/assets/error-picture.svg" />\n  </div>\n  <h2 class="i18n mt16" data-i18n="pageListing.fetchingError"></h2>\n  <p class="i18n" data-i18n="pageListing.fetchingErrorRetry"></p>\n</div>';

}
return __p
};});

